
  <div class="overview" *ngIf="system!==undefined">
      <div class="overview__image-container">
        <div class="overview__image" *ngIf="!loadingSystem"  [@fadeIn]>
            <ng-container *ngIf="system?.SystemType === 1">
                <ng-container *ngIf="FamilyImage_Chain != null">
                    <img [src]="getImage(imageUrl)" class="equipment-photo" />
                </ng-container>
                <ng-container *ngIf="FamilyImage_Chain == null">
                    <img [src]="getSystemImage(system?.SystemType)" class="equipment-photo" />
                </ng-container>
            </ng-container>
            <ng-container *ngIf="system?.SystemType === 2">
                <ng-container *ngIf="FamilyImage_Frame != null">
                    <img [src]="getImage(imageUrl)" class="equipment-photo" />
                </ng-container>
                <ng-container *ngIf="FamilyImage_Frame == null">
                    <img [src]="getSystemImage(system?.SystemType)" class="equipment-photo" />
                </ng-container>
            </ng-container>
        </div>
      </div>
      <div class="overview__content">
        <div class="content__primary">
          <item-group>
            <item [label]="translate('Serial Number')" [primary]="true" [loading]="loadingSystem">
              {{system?.SystemSerialNumber}}
            </item>
          </item-group>
          <!-- <div  class="content__primary-buttons"  *ngIf="!_loadingEquipment"  [@fadeInList] >
            <button  *ngIf="equipmentSelectionLocked" mat-raised-button color="warn" (click)="reSelectEquipment()">
              <mat-icon aria="unlock">lock_open</mat-icon>
              {{ translate("Change Equipment") }}
            </button>
          </div> -->
        </div>
        <div class="content__secondary">
          <div class="special">
            <item-group>
              <!-- <div>
                <item [label]="translate('Customer')" [loading]="loadingSystem" >{{ _selectedEquipment.CustomerName }}</item>
              </div> -->
              <div>
                <item  [label]="translate('Job Site')" [loading]="loadingSystem">{{ system?.JobsiteName }}</item>
              </div>
              <!-- <div>
                <item [label]="translate('Meter Reading (SMU/Hourmeter)')" [loading]="loadingSystem">{{ system.SMU }}</item>
              </div> -->
              <div>
                <!-- <item [label]="translate('Life to Date (LTD)')" [loading]="loadingSystem">{{ system.LTD }}</item > -->
                  <item [label]="translate('CMU')" [loading]="loadingSystem">{{ system.CMU }}</item >
              </div>
              <div>
                <item [label]="translate('Make')" [loading]="loadingSystem" >{{ system.MakeName }}</item>
              </div>
              <div>
                <item [label]="translate('Model')" [loading]="loadingSystem">{{ system.ModelName }}</item>
              </div>
              <!-- <div>
                <item [label]="translate('Family')" [loading]="loadingSystem">{{ _selectedEquipment.Family }}</item>
              </div> -->
              <div></div>
            </item-group>
          </div>
        </div>
      </div>
    </div>
